import {
  branchTimeZoneLabel,
  normalizeBranchTimeZone,
} from "../../shared/delivery-schedule";
import { parseStoredTimestamp } from "../../shared/date-time";

export const formatRupiah = (value: number): string =>
  new Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
    maximumFractionDigits: 0,
  }).format(value);

export const formatDateTime = (
  value?: string,
  timeZone = "Asia/Makassar",
): string => {
  if (!value) return "-";
  const date = new Date(parseStoredTimestamp(value));
  if (Number.isNaN(date.getTime())) return value;
  return new Intl.DateTimeFormat("id-ID", {
    dateStyle: "medium",
    timeStyle: "short",
    timeZone: normalizeBranchTimeZone(timeZone),
  }).format(date);
};

export const formatDateTimeWithZone = (
  value?: string,
  timeZone = "Asia/Makassar",
): string => {
  const formatted = formatDateTime(value, timeZone);
  return formatted === "-"
    ? formatted
    : `${formatted} ${branchTimeZoneLabel(timeZone)}`;
};

export const formatCompactNumber = (value: number): string =>
  new Intl.NumberFormat("id-ID", { maximumFractionDigits: 1 }).format(value);

export const statusLabel = (status: string): string => {
  const labels: Record<string, string> = {
    NEW: "Pesanan Baru",
    WAITING_CONFIRMATION: "Menunggu Konfirmasi",
    CONFIRMED: "Sudah Dikonfirmasi",
    WAITING_PAYMENT: "Menunggu Pembayaran",
    PAID: "Sudah Dibayar",
    PREPARING: "Sedang Disiapkan",
    READY_FOR_PICKUP: "Siap Diambil",
    READY_FOR_DELIVERY: "Siap Dikirim",
    DELIVERING: "Sedang Dikirim",
    COMPLETED: "Selesai",
    CANCELLED: "Dibatalkan",
    REJECTED: "Ditolak",
    UNPAID: "Belum Dibayar",
    WAITING_VERIFICATION: "Menunggu Verifikasi",
    REFUNDED: "Dikembalikan",
    active: "Aktif",
    inactive: "Nonaktif",
    temporarily_closed: "Tutup Sementara",
  };
  return labels[status] ?? status.replaceAll("_", " ");
};

export const humanizeKey = (key: string): string => {
  const aliases: Record<string, string> = {
    id: "ID",
    name: "Nama",
    username: "Username",
    status: "Status",
    total: "Total",
    count: "Jumlah",
    order_number: "Nomor Pesanan",
    orderNumber: "Nomor Pesanan",
    created_at: "Dibuat",
    createdAt: "Dibuat",
    updated_at: "Diperbarui",
    branch_name: "Cabang",
    branchName: "Cabang",
    totalOrders: "Total Pesanan",
    ordersToday: "Pesanan Hari Ini",
    totalCustomers: "Total Pelanggan",
    paidSales: "Penjualan Dibayar",
    lowStock: "Stok Menipis",
    activeBranches: "Cabang Aktif",
    newOrders: "Pesanan Baru",
    preparingOrders: "Sedang Disiapkan",
    readyOrders: "Siap Diserahkan",
    salesToday: "Penjualan Hari Ini",
  };
  return aliases[key] ?? key.replace(/_/g, " ").replace(/([a-z])([A-Z])/g, "$1 $2").replace(/^./, (letter) => letter.toUpperCase());
};
